import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import moment from 'moment';

import Select from '../../../common/components/input/control-suggest-select';
import FormGroup from '@material-ui/core/FormGroup';
import TextField from '@material-ui/core/TextField';
import {DatePicker} from "material-ui-pickers";
import {isNumLetter, getMessage} from '../../../common/utils/validation';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

const styles = theme => ({
	root:{
		width:'100%',
		alignItems:'center'
	},
	selectWrap:{
		width:200,
		marginRight:10,
	},
	radioWrap:{
		marginTop:18,
	},
	textInput : {
		marginTop : '4px',
		width:'180px'
	},
	textInputKey : {
		marginTop : '4px',
		minWidth:'420px',
		width:'calc(100% - 475px)'
	},
	fromTo : {
		padding: '9px 15px 0 15px',
		fontSize: '1.5rem',
		fontFamily: "Roboto, Helvetica, Arial, sans-serif",
		boxSizing:'border-box'
	},


});


class conditionItem extends React.Component {

	constructor(props) {
		super(props);

		const conditionValue = props.conditionValue;
		let conditionSelectValue = null;
		if(conditionValue){
			const conditionSelectValueArray = _.filter(props.conditionSource, {'value' : conditionValue});
			conditionSelectValue = conditionSelectValueArray.length ? conditionSelectValueArray[0] : null;
		}
		this.state = {
			conditionPropsValue : conditionValue,
			conditionSelectValue : conditionSelectValue,
			fromValue:props.fromValue,
			toValue:props.toValue,
			fromError : null,
			toError : null,
			keywordValue:props.keywordValue,
			searchType:props.searchType
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		if(this.state.conditionPropsValue !== nextProps.conditionValue){
			const conditionSelectValueArray = _.filter(nextProps.conditionSource, {'value' : nextProps.conditionValue});
			const conditionSelectValue = conditionSelectValueArray.length ? conditionSelectValueArray[0] : null;
			this.setState({
				conditionSelectValue,
				conditionPropsValue : nextProps.conditionValue
			})
		}
		if(this.state.fromValue !== nextProps.fromValue){
			this.setState({
				fromValue : nextProps.fromValue
			})
		}
		if(this.state.toValue !== nextProps.toValue){
			this.setState({
				toValue : nextProps.toValue
			})
		}
		if(this.state.keywordValue !== nextProps.keywordValue){
			this.setState({
				keywordValue : nextProps.keywordValue
			})
		}
		if(this.state.searchType !== nextProps.searchType){
			this.setState({
				searchType : nextProps.searchType
			})
		}

	}


	/** event handler **/
	handleConditionDivideChange = (data) =>{
		this.setState({
			fromError : null,
			toError : null
		});
		if(this.props.afterChangeFunction) this.props.afterChangeFunction(this.props.dataIndex,"all",{
			value : (data) ? data.value : null,
			fromValue:null,
			toValue:null,
		});
	};

	handleSearchTextFromChange = (event) =>{
		const inputType = this.state.conditionSelectValue.inputType;
		if(inputType === "LETTER_NUMBER" && !isNumLetter(event.target.value)){
			this.setState({
				fromError : getMessage("numLetter"),
				fromValue:event.target.value,
			});
		}
		else{
			this.setState({
				fromError : null
			});
			if(this.props.afterChangeFunction) this.props.afterChangeFunction(this.props.dataIndex,"from",event.target.value);
		}
	};
	handleSearchTextToChange = (event) =>{
		const inputType = this.state.conditionSelectValue.inputType;
		if(inputType === "LETTER_NUMBER" && !isNumLetter(event.target.value)){
			this.setState({
				toError : getMessage("numLetter"),
				toValue:event.target.value,
			});
		}
		else{
			this.setState({
				toError : null
			});
			if(this.props.afterChangeFunction) this.props.afterChangeFunction(this.props.dataIndex,"to",event.target.value);
		}
	};
	handleSearchTextKeywordChange = (event) =>{
		if(this.props.afterChangeFunction) this.props.afterChangeFunction(this.props.dataIndex,"keyword",event.target.value);
	};

	handleDateFromChange = date => {
		let selectedDateTo = this.state.toValue;
		if(selectedDateTo){
			let momentSelectedDateTo = moment(new Date(selectedDateTo).toISOString());
			const dateDiff = momentSelectedDateTo.diff(date,'days');
			if(dateDiff < 0) {
				momentSelectedDateTo = new moment(date);
			}
			else if(dateDiff > 14){
				momentSelectedDateTo = new moment(date);
				momentSelectedDateTo.add(14,'days');
			}
			selectedDateTo = momentSelectedDateTo.format("YYYY/MM/DD");
		}
		const updateArray = {
			fromValue: date.format("YYYY/MM/DD"),
			toValue : selectedDateTo
		};
		if(this.props.afterChangeFunction) this.props.afterChangeFunction(this.props.dataIndex,"fromto",updateArray);
	};
	handleDateFromInputChange = (e) =>{
		if(!e.target.value){
			if(this.props.afterChangeFunction) this.props.afterChangeFunction(this.props.dataIndex,"from",null);
		}
	};
	handleDateToChange = date => {
		let selectedDateFrom = this.state.fromValue;
		if(selectedDateFrom){
			let momentSelectedDateFrom = moment(new Date(selectedDateFrom).toISOString());
			const dateDiff = date.diff(momentSelectedDateFrom,'days');
			if(dateDiff < 0) {
				momentSelectedDateFrom = new moment(date);
			}
			else if(dateDiff > 14){
				momentSelectedDateFrom = new moment(date);
				momentSelectedDateFrom.add(-14,'days');
			}
			selectedDateFrom = momentSelectedDateFrom.format("YYYY/MM/DD");
		}
		const updateArray = {
			fromValue : selectedDateFrom,
			toValue : date.format("YYYY/MM/DD")
		};
		if(this.props.afterChangeFunction) this.props.afterChangeFunction(this.props.dataIndex,"fromto",updateArray);
	};
	handleDateToInputChange = (e) =>{
		if(!e.target.value){
			if(this.props.afterChangeFunction) this.props.afterChangeFunction(this.props.dataIndex,"to",null);
		}
	};
	handleTypeChange = (e) =>{
		this.setState({
			searchType : e.target.value
		});

		if(this.props.afterChangeFunction) this.props.afterChangeFunction(this.props.dataIndex,"searchType",e.target.value);

	};


	render () {
		const { classes,dataIndex,conditionSource,disabled} = this.props;
		const { conditionSelectValue, fromValue, toValue, keywordValue, fromError, toError, searchType} = this.state;

		let conditionDivide = 'STRING';
		let conditionMaxLength = 10;

		if(conditionSelectValue){
			conditionDivide = conditionSelectValue.inputType;
			conditionMaxLength = conditionSelectValue.maxLength;
		}


		const inputDisabled = (!(conditionSelectValue) || disabled);

		const inputForm = () =>{

			const textFromValue = !(fromValue) ? "" : fromValue;
			const textToValue = !(toValue) ? "" : toValue;

			const dateFromValue = !(fromValue) || conditionDivide !== "DATE" ? null : moment(new Date(fromValue).toISOString());
			const dateToValue = !(toValue) || conditionDivide !== "DATE"  ? null : moment(new Date(toValue).toISOString());

			const fromIsError = (fromError !== null);
			const toIsError = (toError !== null);

			switch(conditionDivide){
				case 'STRING':
				case 'LETTER_NUMBER':
					return(
						<FormGroup row>
							<TextField
								label="開始"
								placeholder="開始"
								className={classes.textInput}
								onChange={this.handleSearchTextFromChange}
								name="searchTextFrom"
								inputProps={{
									maxLength:conditionMaxLength
								}}
								value={textFromValue}
								disabled={inputDisabled}
								error={fromIsError}
								helperText={fromError}
							/>
							<div className={classes.fromTo}>-</div>
							<TextField
								label="終了"
								placeholder="終了"
								className={classes.textInput}
								onChange={this.handleSearchTextToChange}
								name="searchTextTo"
								inputProps={{
									maxLength:conditionMaxLength
								}}
								value={textToValue}
								disabled={inputDisabled}
								error={toIsError}
								helperText={toError}
							/>
						</FormGroup>
					);
				case 'DATE':
					return(
						<FormGroup row>
							<DatePicker
								keyboard
								label="開始"
								minDateMessage={"7年前までの日付を入力"}
								maxDateMessage={"10日後までの日付を入力"}
								minDate={new moment().add(-7, 'years')}
								maxDate={new moment().add(10, 'days')}
								value={dateFromValue}
								onChange={this.handleDateFromChange}
								onInputChange={this.handleDateFromInputChange}
								format="YYYY/MM/DD"
								className={classes.textInput}
								invalidDateMessage="日付が正しくありません"
								cancelLabel={"キャンセル"}
								disabled={inputDisabled}
							/>
							<div className={classes.fromTo}>-</div>
							<DatePicker
								keyboard
								label="終了"
								minDateMessage={"7年前までの日付を入力"}
								maxDateMessage={"10日後までの日付を入力"}
								minDate={new moment().add(-7, 'years')}
								maxDate={new moment().add(10, 'days')}
								value={dateToValue}
								onChange={this.handleDateToChange}
								onInputChange={this.handleDateToInputChange}
								className={classes.textInput}
								format="YYYY/MM/DD"
								invalidDateMessage="日付が正しくありません"
								cancelLabel={"キャンセル"}
								disabled={inputDisabled}
							/>
						</FormGroup>
					);
				default:

					return(
						<FormGroup row>
							<TextField
								label="開始"
								placeholder="開始"
								className={classes.textInput}
								onChange={this.handleSearchTextFromChange}
								name="searchTextFrom"
								inputProps={{
									maxLength:conditionMaxLength
								}}
								value={textFromValue}
								disabled={inputDisabled}
							/>
							<div className={classes.fromTo}>-</div>
							<TextField
								label="終了"
								placeholder="終了"
								className={classes.textInput}
								onChange={this.handleSearchTextToChange}
								name="searchTextTo"
								inputProps={{
									maxLength:conditionMaxLength
								}}
								value={textToValue}
								disabled={inputDisabled}
							/>
						</FormGroup>
					);
			}

		};

		const inputFormKeywords = () =>{
			const textKeywordValue = !(keywordValue) ? "" : keywordValue;
			return(
				<TextField
					label="キーワード"
					placeholder="例）「AA　BB　CC」の入力で、あいまい検索になります。"
					className={classes.textInputKey}
					onChange={this.handleSearchTextKeywordChange}
					name="searchTextKey"
					value={textKeywordValue}
					disabled={inputDisabled}
				/>
			);

		};


		return (
			<FormGroup className={classes.root} row>
				<div className={classes.selectWrap}>
					<Select
						inputLabel={"抽出条件"+(dataIndex + 1)}
						suggestions={conditionSource}
						value={conditionSelectValue}
						afterChangeFunction={this.handleConditionDivideChange}
						maxMenuHeight={200}
						disabled={disabled}
					/>

				</div>
				<RadioGroup
					aria-label="gender"
					name="gender2"
					value={searchType}
					onChange={this.handleTypeChange}
					className={classes.radioWrap}
					row
				>
					<FormControlLabel
						value={"2"}
						control={<Radio />}
						label="キーワード検索"
						disabled={inputDisabled}
					/>
					<FormControlLabel
						value={"1"}
						control={<Radio />}
						label="範囲検索"
						disabled={inputDisabled}

					/>
				</RadioGroup>
				{searchType === "1" &&
					inputForm()
				}
				{searchType === "2" &&
					inputFormKeywords()
				}
			</FormGroup>

		);
	}
}
conditionItem.propTypes = {
	conditionValue: PropTypes.string,
	fromValue: PropTypes.string,
	toValue: PropTypes.string,
	keywordValue:PropTypes.string,
	searchType:PropTypes.string,
	conditionSource : PropTypes.array,
	dataIndex:PropTypes.number,
	afterChangeFunc:PropTypes.func,
	disabled:PropTypes.bool,
};
conditionItem.defaultProps = {
	conditionValue: null,
	fromValue: '',
	toValue: '',
	keywordValue:'',
	searchType:"2",
	conditionSource : [],
	dataIndex:1,
	disabled:false
};
export default withStyles(styles)(conditionItem);



// WEBPACK FOOTER //
// ./src/routes/statistics/components/condition-item.js